module.exports = __webpack_public_path__ + "760f3b21f6449aac3ae7a719ca86d52e.svg";